const listDevices = [
  {
    model: "iPhone 6",
    color: "SILVER",
    storage: "16 GB",
    serial_number: "F17RQ03AGRY6",
    uuid: "386feec7aa00a2d61a81f74047b4a650b684b425",
    img: "https://statici.icloud.com/fmipmobile/deviceImages-9.0/iPhone/iPhone8%2C1/online-infobox.png",
  },
  {
    model: "iPhone 13",
    color: "SILVER",
    storage: "128 GB",
    serial_number: "DQ64YXNTQH",
    uuid: "00008110-0018786A3629801E",
    img: "https://statici.icloud.com/fmipmobile/deviceImages-9.0/iPhone/iPhone14%2C5/online-infobox__2x.png",
  },
  {
    model: "iPhone",
    color: "XXX",
    storage: "XXXX",
    serial_number: "WJR429PC4X",
    uuid: "00008110-0016355C2E20A01E",
    img: "https://statici.icloud.com/fmipmobile/deviceImages-9.0/iPhone/iPhone14%2C5/online-infobox__2x.png",
  },
  {
    model: "iPhone",
    color: "XXX",
    storage: "XXXX",
    serial_number: "GHWHQPMWLK",
    uuid: "00008101-001264D43EBA001E",
    img: "https://statici.icloud.com/fmipmobile/deviceImages-9.0/iPhone/iPhone14%2C5/online-infobox__2x.png",
  },
  {
    model: "iPhone",
    color: "XXX",
    storage: "XXXX",
    serial_number: "G09W09V763",
    uuid: "00008110-001625DE0230A01E",
    img: "https://statici.icloud.com/fmipmobile/deviceImages-9.0/iPhone/iPhone14%2C5/online-infobox__2x.png",
  },
];

export default listDevices;
